export default "__VITE_ASSET__DPgFdssM__"